import React from "react";
import { useAppSelector } from "../../redux/hooks";
import SubscriptionBlockedPage from "./SubscriptionBlockedPage";
import { ENABLE_BILLING_MODE } from "../../configs/app-config";

type SubscriptionGuardProps = {
    children: React.ReactNode;
};

const SubscriptionGuard = ({ children }: SubscriptionGuardProps) => {
    const { status, isActive, isLoading } = useAppSelector(
        ({ subscriptionData }) => subscriptionData
    );

    if (!ENABLE_BILLING_MODE) {
        return <>{children}</>;
    }

    if (isLoading) {
        return <>{children}</>;
    }

    if (isActive) {
        return <>{children}</>;
    }

    return <SubscriptionBlockedPage status={status} />;
};

export default SubscriptionGuard;
